import React from "react";
import styled from "styled-components";
import { Colors, Icon } from "@sellout/ui";
import * as Time from "@sellout/utils/.dist/time";
import { Icons } from "@sellout/ui";
import ScrollTable, {
  ScrollTableBody,
  ScrollTableBodyCell,
  ScrollTableBodyRow,
  ScrollTableHeader,
  ScrollTableHeaderCell,
  ScrollTableSpace,
} from "./ScrollableTable";

const StatusBadge = styled.span<{
  status: "Complete" | "Pending" | "Failed" | "Sent";
}>`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: ${(props) => {
    switch (props.status) {
      case "Complete":
      case "Sent":
        return "#E8F5E9";
      case "Pending":
        return "#FFF3E0";
      case "Failed":
      default:
        return "#FFEBEE";
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case "Complete":
      case "Sent":
        return "#2E7D32";
      case "Pending":
        return "#E65100";
      case "Failed":
      default:
        return "#C62828";
    }
  }};
`;

const SubjectCell = styled.div`
  word-break: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.4;
  font-size: 1.3rem;
  color: ${Colors.Grey1};
  text-align: center;
  width: 100%;
`;

const DateCell = styled.div`
  font-size: 1.3rem;
  color: ${Colors.Grey1};
  white-space: nowrap;
`;

type TableHeaderProps = {};

const TableHeader: React.FC<TableHeaderProps> = () => (
  <ScrollTableHeader>
    <ScrollTableHeaderCell width="100px">Date Sent</ScrollTableHeaderCell>
    <ScrollTableSpace />
    <ScrollTableHeaderCell width="200px" justify="center">
      Subject
    </ScrollTableHeaderCell>
    <ScrollTableSpace />
    <ScrollTableHeaderCell width="100px" justify="center">
      Status
    </ScrollTableHeaderCell>
    <ScrollTableSpace />
    <ScrollTableHeaderCell width="60px" justify="center">
      View
    </ScrollTableHeaderCell>
  </ScrollTableHeader>
);

type SentEmailsTableProps = {
  emails: any[];
  eventTimeZone?: string;
  onViewEmail: (email: any) => void;
};

const SentEmailsTable: React.FC<SentEmailsTableProps> = ({
  emails,
  eventTimeZone = "America/Denver",
  onViewEmail,
}) => {
  return (
    <ScrollTable>
      <TableHeader />
      <ScrollTableBody>
        {emails.map((email, index) => (
          <ScrollTableBodyRow
            key={`${email.id || email._id}-${index}`}
            height="50px"
          >
            <ScrollTableBodyCell width="100px">
              <DateCell>
                {Time.format(email.createdAt, "MMM DD, YYYY", eventTimeZone)}
              </DateCell>
            </ScrollTableBodyCell>
            <ScrollTableSpace />
            <ScrollTableBodyCell width="200px" justify="center" style={true}>
              <SubjectCell>{email.subject}</SubjectCell>
            </ScrollTableBodyCell>
            <ScrollTableSpace />
            <ScrollTableBodyCell width="100px" justify="center">
              <StatusBadge status={email.status}>{email.status}</StatusBadge>
            </ScrollTableBodyCell>
            <ScrollTableSpace />
            <ScrollTableBodyCell width="60px" justify="center">
              <Icon
                icon={Icons.EyeLight}
                color={Colors.Grey1}
                size={16}
                onClick={() => onViewEmail(email)}
                hoverColor={Colors.InteractiveBGPrimary}
              />
            </ScrollTableBodyCell>
          </ScrollTableBodyRow>
        ))}
      </ScrollTableBody>
    </ScrollTable>
  );
};

export default SentEmailsTable;
